<div class="reset-password-page min-h-50 text-white">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active" ><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Mot de passe oublié</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            MOT DE PASSE <span style="color : #BADFFF"> OUBLIÉ ?
                            </span>
                        </h1>
                        <h6 class="description">
                            Veuillez renseigner l'e-mail utilisé lors de la création de votre compte. Un email de
                            réinitialisation de mot de passe vous sera envoyé.
                        </h6>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="reset-password-bloc py-5">
        <div class="bloc-reset-password container">
            <div class="bg-white shadow rounded">
                <div class="row">
                    <div class="col-md-7 ">
                        <div class="form-left h-100 py-5 px-5">
                            <form *ngIf="!isMsgSent" #loginForm="ngForm" class="row g-4">
                                <div class="col-12">
                                    <div class="alert alert-danger" *ngIf="showError" [innerHTML]="errorMessage">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label for="reset-email">E-MAIL<span class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <div class="input-group-text"><i class="bi bi-person-fill"></i></div>
                                        <input id="reset-email" type="email" class="form-control" placeholder="Entrer votre e-mail"
                                            pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                            [(ngModel)]="user.login" name="email" #email="ngModel">
                                    </div>
                                </div>

                                <div class="col-12">
                                    <button type="submit" (click)="sendResetPassword(user, false, loginForm.invalid)"
                                        class="btn btn-primary px-4 float-end mt-4">
                                        <div *ngIf="isLoader" class="spinner-border text-light" role="status">
                                        </div>
                                        <span *ngIf="!isLoader"> Continuer</span>
                                    </button>
                                </div>
                            </form>
                            <div *ngIf="isMsgSent" id="form-reinitialise">
                                <div class="text-center">
                                    <h3>Votre mot de passe a été réinitialisé</h3>
                                    <p><i class="icon-mail"></i></p>

                                    <p><strong>Un e-mail vous a été envoyé.</strong> <br>
                                        Suivez les instructions pour
                                        terminer la procédure.</p>
                                    <p><a href="" title="Retour" class="btn btn-bordered-grey"
                                            [routerLink]="['/connexion']"
                                            routerLinkActive="router-link-active">Retour</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 ">
                        <div class="form-right h-100 bg-primary text-white text-start p-5">
                            En demandant à un Conseiller de créer votre compte <span class="blue-text"><strong>THE DOOR
                                    MAN</strong></span>, vous
                            bénéficiez de nombreux services :
                            <div class="clearfix float-content mt-2">
                                <ul>
                                    <li>Informations sauvegardées</li>
                                    <li>Réception des offres par mail</li>
                                    <li>Prise de rendez-vous pour un bien</li>
                                    <li>Enregistrement de vos recherches</li>
                                    <li>Enregistrement de vos biens favoris</li>
                                    <li>Abonnement à la newsletter</li>
                                    <li>Suivi personnalisé</li>
                                </ul>

                                <button [routerLink]="['/amis-tdm/liste']" type="submit"
                                    class="btn btn-outlined  px-4 float-end mt-4">
                                    Trouver mon Conseiller</button>
                                <button [routerLink]="['/connexion']" routerLinkActive="router-link-active"
                                    type="submit" class="btn btn-secondary  px-4 float-end mt-4 mx-2">
                                    Se connecter</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
